import React, { useEffect } from "react";

import styled from "styled-components";
import { Form, Row } from "react-bootstrap";

import ButtonComponent from "../button";

import { StyledFloatingLabel } from "../../../containers/forgetPass/styledForgetPassPage";

const RegisterForm = ({ person, setPerson, personError, inputRef }) => {
  useEffect(() => {
    inputRef.current.focus();
  }, []);

  const registerFormData = [
    {
      id: 1,
      name: "firstName",
      label: "نام",
      type: "text",
      pattern: ".{3,20}",
      minLength: "2",
      maxLength: "25",
      placeholder: "نام",
      value: person.firstName,
      errorValue: personError.firstNameError,
      ref: inputRef,
    },
    {
      id: 2,
      name: "familyName",
      label: "نام‌خانوادگی",
      type: "text",
      placeholder: "نام‌خانوادگی",
      value: person.familyName,
      errorValue: personError.familyNameError,
    },
    {
      id: 3,
      name: "nid",
      label: "کد ملی",
      type: "number",
      placeholder: "کد ملی",
      value: person.nid,
      errorValue: personError.nidError,
    },
    {
      id: 4,
      name: "email",
      label: "ایمیل",
      type: "email",
      placeholder: "ایمیل",
      value: person.email,
      errorValue: personError.emailError,
    },
    {
      id: 5,
      name: "password",
      label: "رمز عبور",
      type: "password",
      placeholder: "رمز عبور",
      value: person.password,
      errorValue: personError.passwordError,
    },
    {
      id: 6,
      name: "confirmPassword",
      label: "تکرار رمز عبور",
      type: "password",
      placeholder: "تکرار رمز عبور",
      value: person.confirmPassword,
      errorValue: personError.confirmPasswordError,
    },
  ];
  const handleRegisterInputsChange = (e) => {
    const { name, value } = e.target;
    setPerson({ ...person, [name]: value });
  };
  return (
    <>
      <StyledRegisterRow className="gy-3">
        {registerFormData.map(
          ({
            id,
            name,
            label,
            type,
            placeholder,
            pattern,
            minLength,
            maxLength,
            value = "",
            errorValue = "",
            ref,
          }) => {
            // debugger;
            return (
              <div className="col-12 col-sm-6 " key={id}>
                <StyledFloatingLabel controlId={name} label={label} $rtl>
                  <Form.Control
                    type={type}
                    name={name}
                    autoComplete="off"
                    placeholder={placeholder}
                    pattern={pattern}
                    minLength={minLength}
                    maxLength={maxLength}
                    value={value}
                    onChange={handleRegisterInputsChange}
                    ref={ref && ref}
                  />
                  {errorValue && (
                    <Form.Text className="position-absolute text-danger">
                      {errorValue}
                    </Form.Text>
                  )}
                </StyledFloatingLabel>
              </div>
            );
          }
        )}
      </StyledRegisterRow>

      <div className="text-center mt-5">
        <ButtonComponent type="submit" className="w-75">
          ثبت‌نام
        </ButtonComponent>
      </div>
    </>
  );
};

const StyledRegisterRow = styled(Row)`
  row-gap: 32px;
`;
export default RegisterForm;
